module.exports = __webpack_public_path__ + "static/media/cloud.427e1aae.svg";